export default "__VITE_ASSET__aTz3AHDB__"